module.exports = __webpack_public_path__ + "img/20191230155815360截图20191230104738567.e0f419ee.jpg";